import { Controller, useFormContext } from "react-hook-form";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import CheckBoxHookForm_2 from "../../../../components/CheckBoxHookForm_2";
import MinusButton from "../../../../components/MinusButton";
import { useEffect, useState } from "react";
import {
  ledAddState,
  ledEditState,
  leAttachments,
  leAttachmentsForDelete,
  leasedEquipmentFromOffice,
  leasedEquipmentOfficeId,
  disableLEOfficeField,
  vendorLeasedId,
  disableLEVendorField,
  leFromVendor,
  leEditMassUpload,
} from "../atom/atom";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import { ILeasedEquipmentDetails } from "../type";
import { useSFGetOffice } from "../../OfficeSettings/hooks/useSFGetOffice";
import { toast } from "../../../../components/toastNotification";
import { useGetVendors } from "../hooks/useGetVendors";
import { useGetLeasedEquipmentMake } from "../hooks/useGetLeasedEquipmentMake";
import { useGetLeasedEquipmentType } from "../hooks/useGetLeasedEquipmentType";
import { useGetLeasedEquipmentModel } from "../hooks/useGetLeasedEquipmentModel";
import { useGetLeasedEquipmentStatus } from "../hooks/useGetLeasedEquipmentStatus";
import { RadioField } from "../../../../components/forms/RadioField";
import { useGetVendorWithVendorStorage } from "../../Vendor/hooks/useGetVendorWithVendorStorage";
import moment from "moment";
import { useGetSupplyAlertProfile } from "../hooks/useGetSupplyAlertProfile";

interface LeasedEquipmentDetailsProp {
  rowForEdit: ILeasedEquipmentDetails | undefined;
  isModalEdit: boolean;
  isOffice: boolean;
}

export const LeasedEquipmentDetails: React.FC<LeasedEquipmentDetailsProp> = ({
  rowForEdit,
  isModalEdit,
  isOffice,
}) => {
  const [isAddState, setAddState] = useRecoilState(ledAddState);
  const [isEditState] = useRecoilState(ledEditState);
  const [isEditMassUpload, setEditMassUpload] =
    useRecoilState(leEditMassUpload);
  const { register, watch, setValue } = useFormContext();
  const formMethods = useFormContext();
  const leOfficeId = useRecoilValue(leasedEquipmentOfficeId);
  const [disableOfficeField] = useRecoilState(disableLEOfficeField);
  const leVendorId = useRecoilValue(vendorLeasedId);
  const [disableVendorField] = useRecoilState(disableLEVendorField);
  //Permission
  const deactivateLeased = PERMISSIONS.permission_leasedequipment_delete;
  const userPermissions = useRecoilValue(permissionsSelector);
  // Attachment
  const [attachments, setAttachments] =
    useRecoilState<(File | null)[]>(leAttachments);
  const [attachmentDisplay, setAttachmentDisplay] = useState<any>(
    watch("fileNames") ? watch("fileNames") : []
  );
  const [attachmentForDelete, setAttachmentForDelete] = useRecoilState<any>(
    leAttachmentsForDelete
  );
  const viewLEFromOffice = useRecoilValue(leasedEquipmentFromOffice);
  const [viewFromLEVendor, setShowFromVendor] = useRecoilState(leFromVendor);

  const removeFile = (fileName) => {
    setAttachmentDisplay(
      attachmentDisplay.filter((x) => x.leasedEquipmentFileName !== fileName)
    );
    setAttachments(attachments.filter((x) => x?.name !== fileName));
    setAttachmentForDelete([
      ...attachmentForDelete,
      attachmentDisplay.filter(
        (x) => x.leasedEquipmentFileName === fileName
      )[0],
    ]);
  };

  useEffect(() => {
    if (!isEditState || !isAddState) {
      setAttachments([]);
    }
    if (leOfficeId) {
      setValue("officeId", leOfficeId);
    }
    if (leVendorId) {
      setValue("vendorStorageId", leVendorId);
    }
  }, [isEditState, isAddState, leOfficeId, leVendorId]);

  //Office Name Dropdown
  const { data: officeName } = useSFGetOffice();

  const sfOfficeNameOpt = officeName?.map((x) => {
    return {
      label: x.officeName,
      value: x.officeId,
    };
  });

  //Vendor Name Dropdown
  const { data: vendorStorage } = useGetVendorWithVendorStorage();

  const vendorNameOpt = vendorStorage?.map((x) => {
    return {
      label: x.name,
      value: x.id,
    };
  });

  //Servicing Dealer Dropdown
  const { data: servicingDealer } = useGetVendors();

  const servicingDealerOpt = servicingDealer?.data?.map((x) => {
    return {
      label: x.name,
      value: x.id,
      email: x.email,
      phone: x.phone,
      tonerRequestEmail: x.tonerRequestEmail,
      tonerRequestPhone: x.tonerRequestPhone,
    };
  });

  const [makeId, setMakeId] = useState<any>(); //state for the being passed

  //Make Dropdown
  const { data: Make } = useGetLeasedEquipmentMake();

  const makeOpt = Make?.data?.map((x) => {
    return {
      value: x.makeId,
      label: x.makeName,
      id: x.makeId,
    };
  });

  const { data: Type } = useGetLeasedEquipmentType();

  const typeOpt = Type?.data?.map((x) => {
    return {
      label: x.typeName,
      value: x.typeId,
      id: x.typeId,
    };
  });

  const { data: leaseEquipmentStatus } = useGetLeasedEquipmentStatus();

  const statusOpt = leaseEquipmentStatus?.data?.map(
    (x: { id: number; leasedEquipmentStatusName: string }) => {
      return {
        value: x.id,
        label: x.leasedEquipmentStatusName,
      };
    }
  );

  const { data: SupplyAlerProfile } = useGetSupplyAlertProfile();

  const supplyAlerProfileOpt = SupplyAlerProfile?.data?.map((x) => {
    return {
      label: x.supplyAlertProfileName,
      value: x.supplyAlertProfileId,
      id: x.typsupplyAlertProfileIdeId,
    };
  });

  //Model/Version Dropdown
  const { data: Model } = useGetLeasedEquipmentModel();

  const modelOpt = Model?.data?.map((x) => {
    return {
      label:
        x.modelName +
        " " +
        (x.description === null ? "" : `(${x.description})`),
      value: x.modelId,
      makeId: x.makeId,
    };
  });

  const associatedOpt = [
    {
      value: "Office",
      label: "Office",
    },
    {
      value: "Vendor Storage",
      label: "Vendor Storage",
    },
  ];

  useEffect(() => {
    const makeValue = formMethods.getValues("makeId");
    if (makeValue) {
      const selectedMake = makeOpt?.find((opt) => opt.value === makeValue);
      if (selectedMake) {
        setMakeId(selectedMake.id);
      }
    }
  }, [formMethods, makeOpt]);

  useEffect(() => {
    if (viewLEFromOffice) {
      formMethods.setValue("officeId", leOfficeId);
    }
    if (viewFromLEVendor) {
      formMethods.setValue("vendorStorageId", leVendorId);
    }
  }, [viewLEFromOffice, viewFromLEVendor]);

  const officeId = watch("officeId");
  const vendorStorageId = watch("vendorStorageId");

  // Function to determine the initial state of associatedWith
  const determineInitialAssociatedWith = () => {
    if (vendorStorageId) {
      return "Vendor Storage";
    } else if (leVendorId) {
      return "Vendor Storage";
    } else if (officeId) {
      return "Office";
    } else {
      return associatedOpt[0].value;
    }
  };
  const [associatedWith, setAssociatedWith] = useState<any>(
    determineInitialAssociatedWith
  );

  //Clear Vendor Name when Office Name have value and vice versa
  useEffect(() => {
    if (associatedWith === "Office") {
      setValue("vendorStorageId", null);
    } else if (associatedWith === "Vendor Storage") {
      setValue("officeId", null);
    }
  }, [officeId, vendorStorageId, setValue]);

  useEffect(() => {
    if (!isOffice) {
      setAssociatedWith("Vendor Storage");
    } else {
      setAssociatedWith("Office");
    }
  }, [isOffice]);

  useEffect(() => {
    const { vendorStorageId, officeId } = formMethods.getValues();

    if (vendorStorageId) {
      formMethods.setValue("associatedWith", "Vendor Storage");
      setAssociatedWith("Vendor Storage");
    } else if (officeId) {
      formMethods.setValue("associatedWith", "Office");
      setAssociatedWith("Office");
    }
  }, [formMethods]);

  return (
    <div className="bg-bgDB">
      <div className="m-2 bg-white box-shadow rounded-lg h-full">
        <div className="text-quinary font-bold font-sans py-2 px-4">
          Details Section
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 mx-4 mr-5 pb-2 gap-12">
          <div className="space-y-1 mr-6">
            <div>
              {/* {!isModalEdit && ( */}
              <>
                {!isModalEdit && (
                  <RadioField
                    options={associatedOpt}
                    value={associatedWith}
                    label={"Associated with:"}
                    name="associatedWith"
                    onChange={(e) => {
                      setAssociatedWith(e.target.value);
                    }}
                    isDisabled={disableVendorField}
                  />
                )}
                {associatedWith === "Office" && (
                  <Controller
                    name={"officeId"}
                    control={formMethods.control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectHookFormSingle
                        field={field}
                        onChange={(e) => {
                          field.onChange(e ? e.value : null);
                        }}
                        value={leOfficeId ? leOfficeId : field.value}
                        options={sfOfficeNameOpt}
                        label="Office Name"
                        className={
                          formMethods.formState.errors.officeId &&
                          "border-2 border-red-500 col-span-2 "
                        }
                        required={true}
                        isDisabled={disableOfficeField}
                      />
                    )}
                  />
                )}
                {associatedWith === "Vendor Storage" && (
                  <Controller
                    name={"vendorStorageId"}
                    control={formMethods.control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <SelectHookFormSingle
                        field={field}
                        onChange={(e) => {
                          field.onChange(e ? e.value : null);
                        }}
                        value={leVendorId ? leVendorId : field.value}
                        options={vendorNameOpt}
                        label="Vendor Name"
                        className={
                          formMethods.formState.errors.vendorId &&
                          "border-2 border-red-500 col-span-2 "
                        }
                        required={true}
                        isDisabled={disableVendorField}
                      />
                    )}
                  />
                )}
              </>
              {/* )} */}
            </div>

            <Controller
              name={"typeId"}
              control={formMethods.control}
              rules={{ required: false }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                  }}
                  value={field.value}
                  options={typeOpt}
                  label="Type"
                  className={
                    formMethods.formState.errors.type &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  required={false}
                />
              )}
            />
            <Controller
              name={"makeId"}
              control={formMethods.control}
              rules={{ required: false }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    setMakeId(e ? e.id : null);
                    formMethods.setValue("modelId", null);
                    if (!formMethods.getValues("modelId")) {
                      formMethods.setValue("modelId", null);
                    }
                    const modelValue = formMethods.getValues("model");
                    const modelOption = modelOpt.find(
                      (x) => x.value === modelValue
                    );
                    if (modelOption && modelOption.makeId !== e.id) {
                      formMethods.setValue("model", null);
                      formMethods.setValue("modelName", null);
                    }
                  }}
                  value={field.value}
                  options={makeOpt}
                  label="Make"
                  className={
                    formMethods.formState.errors.make &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  required={false}
                />
              )}
            />

            <Controller
              name={"modelId"}
              control={formMethods.control}
              rules={{ required: false }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue(
                      "modelName",
                      modelOpt.find((x) => x.id == e.value).label
                    );
                  }}
                  value={field.value}
                  options={
                    modelOpt?.filter((x) => x.makeId === makeId).length > 0 //check if makeId length is truthsy
                      ? modelOpt?.filter((x) => x.makeId === makeId) //dependent drop down
                      : modelOpt //default modelOpt
                    // modelOpt
                  }
                  label="Model/Version"
                  className={
                    formMethods.formState.errors.model &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  required={false}
                  isDisabled={isAddState ? !makeId : false} //disable this on add when there is no make selected
                />
              )}
            />

            <TextInputLabelHookForm
              type="text"
              name="serialNumber"
              label="Equipment ID/Serial Number"
              register={formMethods.register("serialNumber", {})}
              maxLength={255}
            />

            <Controller
              name={"supplyAlertProfileId"}
              control={formMethods.control}
              rules={{ required: false }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                  }}
                  value={field.value}
                  options={supplyAlerProfileOpt}
                  label="Supply Alert Profile"
                  className={
                    formMethods.formState.errors.type &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  required={false}
                />
              )}
            />

            <TextInputLabelHookForm
              type="text"
              name="customerNumber"
              label="Customer Number"
              maxLength={255}
              register={formMethods.register("customerNumber", {
                required: {
                  value: true,
                  message: "Required Field",
                },
              })}
              required={true}
              className={
                formMethods.formState.errors.customerNumber &&
                "border-2 border-red-500 col-span-2 "
              }
              secondDiv="grid grid-cols-3 w-full items-center gap-2"
            />

            <TextInputLabelHookForm
              type="text"
              name="vendorLocationNumber"
              label="Vendor Location No."
              maxLength={255}
              register={formMethods.register("vendorLocationNumber", {
                required: {
                  value: true,
                  message: "Required Field",
                },
              })}
              required={true}
              className={
                formMethods.formState.errors.vendorLocationNumber &&
                "border-2 border-red-500 col-span-2 "
              }
              secondDiv="grid grid-cols-3 w-full items-center gap-2"
            />

            <TextInputLabelHookForm
              type="text"
              name="purchasingVendorNumber"
              label="Purchasing Vendor & Phone Number"
              maxLength={255}
              pattern="(\(\d{3}\)) \d{3}[-]\d{4}"
              placeholder="(000) 000-0000"
              register={formMethods.register("purchasingVendorNumber", {
                required: {
                  value: true,
                  message: "Required Field",
                },
              })}
              onChange={(e) => {
                var x = e.target.value
                  .replace(/\D/g, "")
                  .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                e.target.value = !x[2]
                  ? x[1]
                  : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
              }}
              required={true}
              className={
                formMethods.formState.errors.purchasingVendorNumber &&
                "border-2 border-red-500 col-span-2 "
              }
              secondDiv="grid grid-cols-3 w-full items-center gap-2"
            />

            {/* <TextInputLabelHookForm
              type="text"
              name="leaseAmount"
              label="Lease Amount"
              register={formMethods.register("leaseAmount", {})}
              maxLength={255}
            /> */}
            {!isModalEdit && (
              <TextInputLabelHookForm
                type="text"
                name="leaseAmount"
                label="Lease Amount"
                register={formMethods.register("leaseAmount", {})}
                maxLength={255}
              />
            )}

            {!isModalEdit && (
              <TextInputHookFormDisabled
                name={"previousOfficeName"}
                type="text"
                label="Previous Location"
                register={formMethods.register("previousOfficeName", {})}
              />
            )}
            {!isModalEdit && (
              <TextInputLabelHookForm
                type="text"
                name="returnedEquipmentRm"
                label="Returned Equipment RM#"
                register={formMethods.register("returnedEquipmentRm", {})}
                maxLength={255}
              />
            )}
            {!isModalEdit && (
              <TextInputLabelHookForm
                type="date"
                name="returnedEquipmentDate"
                label="Returned Equipment Date"
                register={formMethods.register("returnedEquipmentDate", {})}
              />
            )}
          </div>
          <div className="space-y-1">
            {!isModalEdit && (
              <TextInputLabelHookForm
                type="text"
                name="tagNumber"
                label="Tag Number"
                register={formMethods.register("tagNumber", {})}
                maxLength={25}
              />
            )}
            {!isModalEdit && (
              <TextInputLabelHookForm
                type="text"
                name="ipaddress"
                label="IP Address"
                register={formMethods.register("ipaddress", {})}
                maxLength={15}
              />
            )}
            <Controller
              name={"statusId"}
              control={formMethods.control}
              rules={{ required: false }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("status", e ? e.label : null);
                  }}
                  value={field.value}
                  options={statusOpt}
                  label="Status"
                  className={
                    formMethods.formState.errors.statusId &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  required={false}
                />
              )}
            />
            {[3].includes(formMethods.watch("statusId")) && isAddState ? (
              <CheckBoxHookForm_2
                name="isActive"
                type="checkbox"
                label="Inactive Storage"
                hasPermission
                disabled={false}
                className={
                  formMethods.formState.errors.isActive &&
                  formMethods.formState.errors.isActive.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={register}
                validation={undefined}
              />
            ) : (
              [3].includes(formMethods.watch("statusId")) &&
              userPermissions.includes(deactivateLeased) && (
                <CheckBoxHookForm_2
                  name="isActive"
                  type="checkbox"
                  label="Inactive Storage"
                  hasPermission
                  disabled={false}
                  className={
                    formMethods.formState.errors.isActive &&
                    formMethods.formState.errors.isActive.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={register}
                  validation={undefined}
                />
              )
            )}
            {!isModalEdit && (
              <CheckBoxHookForm_2
                name="equipmentReturned"
                type="checkbox"
                label="Equipment Returned:"
                validation={{
                  required: {
                    value: false,
                    message: "Required Field",
                  },
                }}
                hasPermission
                disabled={false}
                className={
                  formMethods.formState.errors.equipmentReturned &&
                  formMethods.formState.errors.equipmentReturned.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={register}
              />
            )}

            {!isModalEdit && (
              <TextInputLabelHookForm
                type="text"
                name="leaseNumber"
                label="Lease Number"
                register={formMethods.register("leaseNumber", {})}
                maxLength={25}
              />
            )}
            {!isModalEdit && (
              <TextInputLabelHookForm
                type="date"
                name="leaseStartDate"
                label="Lease Start Date"
                register={formMethods.register("leaseStartDate", {})}
              />
            )}
            {!isModalEdit && (
              <TextInputLabelHookForm
                type="date"
                name="leaseEndDate"
                label="Lease End Date"
                register={formMethods.register("leaseEndDate", {})}
              />
            )}
            {!isModalEdit && (
              <TextInputLabelHookForm
                type="date"
                name="cancellationDate"
                label="Cancellation Date"
                register={formMethods.register("cancellationDate", {})}
              />
            )}

            <Controller
              name={"vendorId"}
              control={formMethods.control}
              rules={{ required: false }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("email", e?.email);
                    formMethods.setValue("phone", e?.phone);
                    formMethods.setValue(
                      "tonerRequestEmail",
                      e?.tonerRequestEmail
                    );
                    formMethods.setValue(
                      "tonerRequestPhone",
                      e?.tonerRequestPhone
                    );
                  }}
                  value={field.value}
                  options={servicingDealerOpt}
                  label="Servicing Dealer"
                  className={
                    formMethods.formState.errors.vendorId &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  required={false}
                />
              )}
            />

            {formMethods.watch("vendorId") > 0 && (
              <div className="space-y-2">
                <TextInputHookFormDisabled
                  name="phone"
                  type="text"
                  label="Servicing Dealer Phone Number"
                  register={formMethods.register("phone", {})}
                />
                <TextInputHookFormDisabled
                  name="email"
                  type="text"
                  label="Service Dealer Email"
                  register={formMethods.register("email", {})}
                />
                <TextInputHookFormDisabled
                  name="tonerRequestEmail"
                  type="text"
                  label="Toner Request Email"
                  register={formMethods.register("tonerRequestEmail", {})}
                />
                <TextInputHookFormDisabled
                  name="tonerRequestPhone"
                  type="text"
                  label="Toner Request Phone"
                  register={formMethods.register("tonerRequestPhone", {})}
                />
                <TextInputLabelHookForm
                  type="hidden"
                  name="model"
                  register={formMethods.register("model", {})}
                  maxLength={255}
                />
                {/* <input type="hidden" {...register("make")} />
                <input type="hidden" {...register("type")} /> */}
              </div>
            )}
          </div>
        </div>
      </div>

      {!isModalEdit && (
        <div className="m-2 bg-white box-shadow rounded-lg h-full">
          <div className="text-quinary font-bold font-sans py-2 px-4">
            Notes & Attachment
          </div>
          <div className="space-y-1 mx-2">
            <div className="text-xs">
              <div className="">
                {attachmentDisplay?.length > 0 &&
                  attachmentDisplay?.map((file, i) => {
                    return (
                      <div
                        key={i}
                        className="bg-LightWhite flex justify-between px-2 py-1 mx-2"
                      >
                        <div className="font-semibold text-left text-primary pr-2">
                          {file.leasedEquipmentFileName}
                        </div>
                        <div className="flex items-center">
                          <MinusButton
                            onClick={() => {
                              removeFile(file.leasedEquipmentFileName);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="flex justify-center py-2">
                <label
                  className=" text-center bg-primary text-white
                   py-1 px-3 border font-medium rounded-full cursor-pointer hover:bg-white hover:text-primary hover:border-primary"
                >
                  <input
                    type="file"
                    className="hidden"
                    onChange={(e) => {
                      if (e.target.files && e.target.files.length > 0) {
                        var reader = new FileReader();

                        reader.readAsDataURL(e.target.files[0]);
                        reader.onload = () => {
                          var rowIndex = attachmentDisplay.findIndex(
                            (obj) => obj === e?.target?.files?.item(0)?.name
                          );

                          if (rowIndex < 0) {
                            setAttachmentDisplay([
                              ...attachmentDisplay,
                              {
                                leasedEquipmentFileName:
                                  e?.target?.files?.item(0)?.name,
                              },
                            ]);

                            const newFile = e.target.files
                              ? e.target.files.item(0)
                              : null;
                            if (attachments[0]) {
                              setAttachments((old) => [...old, newFile]);
                            } else {
                              setAttachments([newFile]);
                            }
                          } else {
                            toast.fire(
                              "Attachment failed",
                              "File already exist",
                              "error"
                            );
                          }
                        };
                      }
                    }}
                  />
                  Choose File
                </label>
              </div>
            </div>
          </div>
        </div>
      )}
      {formMethods.watch("recordNumber") && isEditState ? (
        <div className="m-2 bg-white box-shadow rounded-lg h-full">
          <div className="text-quinary font-bold font-sans py-2 px-4">
            System Information
          </div>
          <div className="grid grid-cols-1 md:grid-cols-1 mx-4 mr-5 pb-2 gap-12">
            <div className="space-y-1 mr-6">
              <div className="grid grid-cols-1 md:grid-cols-2 mr-5 pb-2 gap-12">
                <div className="space-y-1 mr-6 mt-1">
                  <TextInputHookFormDisabled
                    label="Created By"
                    name="createdBy"
                    register={formMethods.register("createdBy", {})}
                  />
                </div>
                <div className="space-y-1 mr-6">
                  <div className="grid grid-cols-3 p-2">
                    <label className="col-span-1 mx-4 expandedLabel fontExpand">
                      Created Date:
                    </label>
                    <div className="flex space-x-1 justify-start expandedLabel fontExpand">
                      <span className="pr-2">
                        {rowForEdit?.createdDate &&
                          moment(rowForEdit?.createdDate).format(
                            "M/D/YYYY hh:mm A"
                          )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 mr-5 pb-2 gap-12">
                <div className="space-y-1 mr-6 mt-1">
                  <TextInputHookFormDisabled
                    label="Last Modified By"
                    name="lastModifiedBy"
                    register={formMethods.register("lastModifiedBy", {})}
                  />
                </div>
                <div className="space-y-1 mr-6">
                  <div className="grid grid-cols-3 p-2">
                    <label className="col-span-1 mx-4 expandedLabel fontExpand">
                      Last Modified Date:
                    </label>
                    <div className="flex space-x-1 justify-start expandedLabel fontExpand">
                      <span className="pr-2">
                        {rowForEdit?.modifiedDate &&
                          moment(rowForEdit?.modifiedDate).format(
                            "M/D/YYYY hh:mm A"
                          )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
